// src/pages/Company.tsx

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import InquireComponent from "../components/Inquire.tsx";

const Container = styled.div`
  width: auto;
  height: auto;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 1550px) {
    width: auto;
  }
`;

const CustomContainer = styled.div<{
  padding?: string;
  marginTop?: string;
  width?: string;
  height?: string;
  backgroundColor?: string;
  borderRadius?: string;
  display?: string;
  alignItems?: string;
  justifyContent?: string;
  flexDirection?: string;
  gap?: string;
  border?: string;

  // 반응형 옵션
  mobilePadding?: string;
  mobileMargin?: string;
  mobileWidth?: string;
  mobileHeight?: string;
  mobileBackgroundColor?: string;
  mobileBorderRadius?: string;
  mobileDirection?: string;
  mobileGap?: string;
  mobileMarginTop?: string;
}>`
  display: ${({ display = "flex" }) => display};
  padding: ${({ padding = "0px 0px 0px 0px" }) => padding};
  margin-top: ${({ marginTop = "0" }) => marginTop};
  width: ${({ width = "100%" }) => width};
  height: ${({ height = "auto" }) => height};
  background-color: ${({ backgroundColor = "transparent" }) => backgroundColor};
  border-radius: ${({ borderRadius = "0" }) => borderRadius};
  border: ${({ border = "none" }) => border};
  align-items: ${({ alignItems = "center" }) => alignItems};
  justify-content: ${({ justifyContent = "center" }) => justifyContent};
  flex-direction: ${({ flexDirection = "row" }) => flexDirection};
  gap: ${({ gap = "0" }) => gap};
  box-sizing: border-box;

  @media (max-width: 1550px) {
    padding: ${({ mobilePadding }) => mobilePadding || "inherit"};
    margin: ${({ mobileMargin }) => mobileMargin || "inherit"};
    width: ${({ mobileWidth }) => mobileWidth || "inherit"};
    height: ${({ mobileHeight }) => mobileHeight || "inherit"};
    background-color: ${({ mobileBackgroundColor }) =>
      mobileBackgroundColor || "inherit"};
    border-radius: ${({ mobileBorderRadius }) =>
      mobileBorderRadius || "inherit"};
    flex-direction: ${({ mobileDirection }) => mobileDirection || "inherit"};
    gap: ${({ mobileGap }) => mobileGap || "inherit"};
    margin-top: ${({ mobileMarginTop }) => mobileMarginTop || "inherit"};
  }
`;

const Text = styled.div<{
  marginTop?: string;
  color?: string;
  fontWeight?: string | number;
  fontSize?: string;

  mobileMarginTop?: string; // 모바일 전용 margin-top
  mobileFontSize?: string; // 모바일 전용 font-size
  mobileTextAlign?: string; // 모바일 전용 text-align
}>`
  display: flex;
  margin-top: ${({ marginTop = "0" }) => marginTop};
  color: ${({ color = "white" }) => color};
  font-weight: ${({ fontWeight = "bold" }) => fontWeight};
  font-size: ${({ fontSize = "32px" }) => fontSize};
  font-family: "Pretendard";
  text-align: center;
  white-space: pre-wrap;
  word-break: break-word;

  @media (max-width: 1550px) {
    font-size: ${({ mobileFontSize }) => mobileFontSize || "inherit"};
    margin-top: ${({ mobileMarginTop = "30px" }) => mobileMarginTop};
    text-align: ${({ mobileTextAlign }) => mobileTextAlign || "inherit"};
    white-space: pre-wrap;
  }
`;

const CardContainer = styled.div`
  display: flex; // flexbox로 가로로 배치
  justify-content: space-between; // 카드들 사이의 간격을 동일하게
  align-items: center;
  height: auto;
  width: auto;
  gap: 50px; // 카드 간의 간격 설정
  margin-top: 20px;
  padding: 20px 20px; // 카드들 양쪽에 여백 추가

  @media (max-width: 1550px) {
    margin-top: 20px;
    flex-direction: column; // 화면이 작을 때 세로로 배치
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }
`;

const CardTextWrapper = styled.div`
  margin-top: 10px;
  height: auto;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1550px) {
    margin-top: 0px;
  }
`;

const Card = styled.div<{ bgColor: string; textColor: string }>`
  width: 339px; // 카드의 너비 설정
  height: 306px; // 카드의 높이 설정
  background-color: #ffffff1c;
  border-radius: 8px; // 둥근 모서리
  padding: 20px;
  display: flex;
  flex-direction: column; // 아이콘과 텍스트 세로로 배치
  align-items: center; // 가운데 정렬
  justify-content: center;
  font-family: "Pretendard"; // 폰트 설정
  box-sizing: border-box;

  @media (max-width: 1550px) {
    width: 333px;
    height: 156px;
    display: flex;
    gap: 10px;
    flex-direction: row;
  }
`;

// 이미지 스타일 설정 (상단에 위치, width와 height를 props로 받음)
const Icon = styled.img<{
  width: string;
  height: string;
  marginBottom?: string;
  borderRadius?: string;
  border?: string;
  mobileWidth?: string;
  mobileHeight?: string;
  mobileMargin?: string;
}>`
  width: ${(props) => props.width}; // width 설정
  height: ${(props) => props.height}; // height 설정
  margin-bottom: ${(props) => props.marginBottom}; // height 설정
  border-radius: ${(props) => props.borderRadius}; // border-radius 설정
  border: ${(props) => props.border}; // border 설정
  @media (max-width: 1550px) {
    margin-bottom: 5px;
    height: ${(props) => props.mobileHeight};
    width: ${(props) => props.mobileWidth};
    margin: ${(props) => props.mobileMargin};
  }
`;
const IntoductionContainer = styled.div`
  display: flex;
  height: auto;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
`;

const IntroComponent = styled.div`
  display: flex;
  width: 368px;
  height: 200px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 20px;
  padding: 20px;
`;

const IntroButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #00e186; // 버튼 배경 색
  color: black; // 버튼 텍스트 색
  font-size: 18px; // 텍스트 크기
  font-weight: 600;
  font-family: "Pretendard";
  padding: 10px 12px; // 여백
  border-radius: 100px; // 둥근 모서리
  box-sizing: border-box;
  margin: 10px; // 버튼 간의 간격
  width: 230px;
  height: 55px;

  @media (max-width: 1550px) {
    width: 200px;
    height: 50px;
    gap: 10px;
    font-size: 20px;
    margin: 10px;
  }
`;
const ButtonTextSize = styled.div`
  width: 168px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const Line = styled.div`
  width: 1px;
  height: 100%;
  background-color: #353535;
  margin-left: 10px;
  margin-right: 10px;
`;

const MarketingFlowContainer = styled.div`
  display: flex;
  height: auto;
  width: 100%;
  gap: 50px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
`;

const MarketingTextBox = styled.div`
  display: flex;
  height: 100%;
  width: auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const AlignLeft = styled.div`
  text-align: left; /* 텍스트를 왼쪽 정렬 */
  display: block; /* Flex 대신 Block으로 설정 */
  white-space: pre-wrap; /* 줄바꿈 허용 */
  word-break: break-word; /* 단어가 너무 길 경우 잘림 */
`;

const MarketProcessContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  width: auto;
  gap: 20px;
  justify-content: center;
`;

const ProcessComponent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px; /* 원형의 너비 */
  height: 150px; /* 원형의 높이 */
  background-color: white; /* 원형의 배경색 */
  border-radius: 50%; /* 원형 모양 */
`;

const BoldText = styled.span`
  font-weight: bold;
`;

function Marketing() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1550);
    handleResize(); // 초기 화면 크기 체크
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardData1 = [
    {
      titleText: "브랜드 스토리텔링",
      summaryText: "고객의 감성을 자극하는\n강력한 브랜드 내러티브 구축",
      mobileTitleText: "브랜드 스토리텔링",
      mobileSummaryText: "고객의 감성을 자극하는\n강력한 브랜드 내러티브 구축",
      imgSrc: "/images/marketing_icon/image1.png", // 이미지 파일 경로 (로컬 경로)
      imgWidth: "70px", // 이미지 너비 설정
      imgHeight: "90px", // 이미지 높이 설정
      mobileWidth: "38px",
      mobileHeight: "47px",
    },
    {
      titleText: "디지털 브랜딩",
      summaryText: "웹사이트, SNS, 모바일 앱을\n통한 일관된 브랜드 경험 제공",
      imgSrc: "/images/marketing_icon/image2.png", // 이미지 파일 경로 (로컬 경로)
      imgWidth: "132px", // 이미지 너비 설정
      imgHeight: "100px", // 이미지 높이 설정
      mobileWidth: "52px",
      mobileHeight: "39px",
    },
    {
      titleText: "브랜드 포지셔닝",
      summaryText: "경쟁사와 차별화 된\n유니크한 시장 포지션 확립",
      imgSrc: "/images/marketing_icon/image3.png", // 이미지 파일 경로 (로컬 경로)
      imgWidth: "70px", // 이미지 너비 설정
      imgHeight: "90px", // 이미지 높이 설정
      mobileWidth: "41px",
      mobileHeight: "41px",
    },
  ];
  const cardData2 = [
    {
      titleText: "전문성 있는 맞춤 컨텐츠 제작",
      summaryText: "클라이언트 별로 \n특화된 컨텐츠 제작",
      mobileTitleText: "전문성 있는\n맞춤 컨텐츠 제작",
      imgSrc: "/images/marketing_icon/image4.png", // 이미지 파일 경로 (로컬 경로)
      imgWidth: "113px", // 이미지 너비 설정
      imgHeight: "101px", // 이미지 높이 설정
      mobileWidth: "53px",
      mobileHeight: "47px",
    },
    {
      titleText: "합리적인 비용",
      summaryText:
        "클라이언트에게 맞춰진 합리적인 비용을\n바탕으로 실질적인 결과를 만들어냅니다.",
      mobileSummaryText:
        "클라이언트에게 맞춰진\n합리적인 비용을 바탕으로\n실질적인 결과를 만들어냅니다.",
      imgSrc: "/images/marketing_icon/image5.png", // 이미지 파일 경로 (로컬 경로)
      imgWidth: "118px", // 이미지 너비 설정
      imgHeight: "90px", // 이미지 높이 설정
      mobileWidth: "50px",
      mobileHeight: "38px",
    },
  ];

  const combinedCardData = cardData1.concat(cardData2);
  const processData = [
    {
      titleText: "계약체결",
      summaryText: "첫 미팅을 거쳐 콘텐츠\n제작 계약을 체결합니다.",
      imgSrc: "/images/marketing_icon/flow_icon/image.png", // 이미지 파일 경로 (로컬 경로)
      imgWidth: "91px", // 이미지 너비 설정
      imgHeight: "108px", // 이미지 높이 설정
    },
    {
      titleText: "컨설팅",
      summaryText: "원장님과 함께 병원 브랜드 파악\n및 콘텐츠를 기획합니다.",
      imgSrc: "/images/marketing_icon/flow_icon/image2.png", // 이미지 파일 경로 (로컬 경로)
      imgWidth: "75px", // 이미지 너비 설정
      imgHeight: "90px", // 이미지 높이 설정
    },
    {
      titleText: "마케팅 집행",
      summaryText: "콘텐츠를 제작하고\n마케팅을 집행합니다.",
      imgSrc: "/images/marketing_icon/flow_icon/image3.png", // 이미지 파일 경로 (로컬 경로)
      imgWidth: "85px", // 이미지 너비 설정
      imgHeight: "85px", // 이미지 높이 설정
    },
    {
      titleText: "보고서 전달",
      summaryText: "업무 내용에 대한\n전반적인 내용을 보고합니다.",
      imgSrc: "/images/marketing_icon/flow_icon/image4.png", // 이미지 파일 경로 (로컬 경로)
      imgWidth: "91px", // 이미지 너비 설정
      imgHeight: "108px", // 이미지 높이 설정
    },
  ];
  return (
    <Container id="container">
      {isMobile ? (
        <>
          <CustomContainer id="topText" mobile Width="100%" mobileHeight="auto">
            <Text
              mobileMarginTop="60px"
              fontSize="24px"
              fontWeight="Bold"
              mobileFontSize="27px"
              textAlign="center"
            >
              많은 사람들이
            </Text>
            <Text
              mobileMarginTop="5px"
              fontSize="24px"
              fontWeight="Bold"
              mobileFontSize="27px"
              textAlign="center"
            >
              슬라임을 선택한 이유?
            </Text>
            <Text marginTop="10px" fontSize="16px" fontWeight="Regular">
              슬라임은 이커머스와 뷰티, 의료 분야에 특화된{"\n"} 종합적인 브랜드
              마케팅 솔루션을 제공합니다.
            </Text>
          </CustomContainer>
        </>
      ) : (
        <>
          <Text marginTop="140px" fontSize="32px" fontWeight="Bold">
            많은 사람들이 슬라임을 선택한 이유?
          </Text>
          <Text marginTop="20px" fontSize="18px" fontWeight="Regular">
            슬라임은 이커머스와 뷰티, 의료 분야에 특화된 종합적인 브랜드 마케팅
            솔루션을 제공합니다.
          </Text>
        </>
      )}
      {isMobile ? (
        <>
          <CustomContainer
            mobileDirection="column"
            width="100%"
            mobileGap="10px"
            mobileMarginTop="10px"
            mobilePadding="0px 10px 0px 10px"
          >
            {combinedCardData.map((card, index) => (
              <CustomContainer
                mobileDirection="row"
                mobileWidth="333px"
                mobileHeight="156px"
                mobileBorderRadius="10px"
                mobileGap="10px"
                mobileBackgroundColor="#ffffff1c"
                key={index}
              >
                {/* 이미지 대신 Icon을 img로 대체, 너비와 높이를 설정 */}
                <CustomContainer
                  mobileBackgroundColor="transparent"
                  mobileWidth="50px"
                >
                  <Icon
                    src={card.imgSrc}
                    alt="icon"
                    width={card.imgWidth}
                    height={card.imgHeight}
                    mobileHeight={card.mobileHeight}
                    mobileWidth={card.mobileWidth}
                  />
                </CustomContainer>
                <CustomContainer
                  mobileDirection="column"
                  id="cardText"
                  width="100%"
                  alignItems="flex-start"
                  mobileBackgroundColor="transparent"
                  mobileMarginTop="0px"
                >
                  <Text
                    fontSize="22px"
                    fontWeight="Bold"
                    color="#00E186"
                    mobileMarginTop="0px"
                    mobileFontSize="25px"
                  >
                    {isMobile
                      ? card.mobileTitleText || card.titleText // 모바일 전용 텍스트가 있으면 사용
                      : card.titleText}
                  </Text>
                  <Text
                    fontSize="17px"
                    fontWeight="Regular"
                    mobileFontSize="19px"
                    textAlign="left"
                    mobileMarginTop="0px"
                  >
                    {isMobile
                      ? card.mobileSummaryText || card.summaryText // 모바일 전용 텍스트가 있으면 사용
                      : card.summaryText}
                  </Text>
                </CustomContainer>
              </CustomContainer>
            ))}
          </CustomContainer>
        </>
      ) : (
        <>
          <CardContainer>
            {cardData1.map((card, index) => (
              <Card key={index}>
                {/* 이미지 대신 Icon을 img로 대체, 너비와 높이를 설정 */}
                <Icon
                  src={card.imgSrc}
                  alt="icon"
                  width={card.imgWidth}
                  height={card.imgHeight}
                  mobileHeight={card.mobileHeight}
                  mobileWidth={card.mobileWidth}
                />
                <CardTextWrapper>
                  <Text
                    fontSize="22px"
                    fontWeight="Bold"
                    color="#00E186"
                    mobileFontSize="25px"
                    marginTop="10px"
                  >
                    {card.titleText}
                  </Text>
                  <Text
                    fontSize="17px"
                    fontWeight="Regular"
                    marginTop="10px"
                    mobileFontSize="19px"
                  >
                    {card.summaryText}
                  </Text>
                </CardTextWrapper>
              </Card>
            ))}
          </CardContainer>
          <CardContainer>
            {cardData2.map((card, index) => (
              <Card key={index}>
                {/* 이미지 대신 Icon을 img로 대체, 너비와 높이를 설정 */}
                <Icon
                  src={card.imgSrc}
                  alt="icon"
                  width={card.imgWidth}
                  height={card.imgHeight}
                  marginBottom="10px"
                />
                <Text fontSize="22px" fontWeight="Bold" color="#00E186">
                  {card.titleText}
                </Text>
                <Text fontSize="17px" fontWeight="Regular" marginTop="10px">
                  {card.summaryText}
                </Text>
              </Card>
            ))}
          </CardContainer>
        </>
      )}

      {isMobile ? (
        <>
          <CustomContainer
            mobileDirection="column"
            width="100%"
            mobileGap="5px"
            mobileMarginTop="50px"
          >
            <Text mobileFontSize="27px">국내마케팅</Text>
            <CustomContainer
              mobileDirection="row"
              mobileWidth="223px"
              mobileHeight="55px"
              mobileMarginTop="10px"
              mobileBackgroundColor="#00E186"
              mobileBorderRadius="100px"
            >
              <Text color="black" mobileFontSize="16px" mobileMarginTop="0px">
                병의원 마케팅 소개서
              </Text>
              <Icon
                src="./images/marketing_icon/arrow.png"
                width="26px"
                height="26px"
                margin="0px"
                mobileMargin="0px"
              />
            </CustomContainer>
            <CustomContainer
              mobileDirection="row"
              mobileWidth="223px"
              mobileHeight="55px"
              mobileMarginTop="10px"
              mobileBackgroundColor="#00E186"
              mobileBorderRadius="100px"
            >
              <Text color="black" mobileFontSize="16px" mobileMarginTop="0px">
                이커머스 마케팅 소개서
              </Text>
              <Icon
                src="./images/marketing_icon/arrow.png"
                width="26px"
                height="26px"
                margin="0px"
                mobileMargin="0px"
              />
            </CustomContainer>

            <Text mobileFontSize="27px" marginTop="20px">
              글로벌 마케팅(일본)
            </Text>
            <CustomContainer
              mobileDirection="row"
              mobileWidth="223px"
              mobileHeight="55px"
              mobileMarginTop="10px"
              mobileBackgroundColor="#00E186"
              mobileBorderRadius="100px"
            >
              <Text color="black" mobileFontSize="16px" mobileMarginTop="0px">
                병의원 마케팅 소개서
              </Text>
              <Icon
                src="./images/marketing_icon/arrow.png"
                width="26px"
                height="26px"
                margin="0px"
                mobileMargin="0px"
              />
            </CustomContainer>
          </CustomContainer>
        </>
      ) : (
        <>
          {" "}
          <IntoductionContainer>
            <IntroComponent>
              <Text
                fontSize="32px"
                fontWeight="Bold"
                color="white"
                mobileFontSize="27px"
              >
                국내 마케팅
              </Text>
              <IntroButton>
                <ButtonTextSize>
                  <Text fontSize="18px" color="black">
                    병의원 마케팅 소개서
                  </Text>
                </ButtonTextSize>
                <Icon
                  src="./images/marketing_icon/arrow.png"
                  width="26px"
                  height="26px"
                  margin="0px"
                />
              </IntroButton>
              <IntroButton>
                <ButtonTextSize>
                  <Text fontSize="18px" color="black">
                    이커머스 마케팅 소개서
                  </Text>
                </ButtonTextSize>
                <Icon
                  src="./images/marketing_icon/arrow.png"
                  width="26px"
                  height="26px"
                  margin="0px"
                />
              </IntroButton>
            </IntroComponent>
            <Line />
            <IntroComponent>
              <Text fontSize="32px" fontWeight="Bold" color="white">
                글로벌 마케팅(일본)
              </Text>
              <IntroButton>
                <ButtonTextSize>
                  <Text fontSize="18px" color="black">
                    병의원 마케팅 소개서
                  </Text>
                </ButtonTextSize>
                <Icon
                  src="./images/marketing_icon/arrow.png"
                  width="26px"
                  height="26px"
                  margin="0px"
                />
              </IntroButton>
            </IntroComponent>
          </IntoductionContainer>
        </>
      )}
      {isMobile ? (
        <>
          <CustomContainer mobileMarginTop="50px">
            <Text mobileFontSize="27px" mobileMarginTop="10px">
              마케팅 컨텐츠 제작을
            </Text>
            <Text mobileFontSize="27px" mobileMarginTop="5px">
              위한 맞춤형 컨설팅 진행
            </Text>
            <Text
              mobileFontSize="16px"
              mobileMarginTop="10px"
              fontWeight="Regular"
            >
              모든 과정은 슬라임 대표가 직접 관여합니다.
            </Text>
            <CustomContainer mobileMarginTop="20px" mobileGap="50px">
              {processData.map((data, index) => (
                <>
                  <CustomContainer
                    mobileDirection="column"
                    mobileMarginTop="20px"
                    mobileGap="5px"
                  >
                    <Icon
                      src={data.imgSrc}
                      width={data.imgWidth}
                      height={data.imgHeight}
                    />
                    <Text
                      color="#00E186"
                      mobileFontSize="25px"
                      mobileMarginTop="0px"
                    >
                      {data.titleText}
                    </Text>
                    <Text
                      mobileFontSize="17px"
                      color="white"
                      fontWeight="Regular"
                      mobileMarginTop="0px"
                      textAlign="center"
                      mobileWidth="100%"
                      mobileTextAlign="center"
                    >
                      {data.summaryText}
                    </Text>
                  </CustomContainer>
                </>
              ))}
            </CustomContainer>
          </CustomContainer>
        </>
      ) : (
        <>
          {" "}
          <MarketingFlowContainer>
            <MarketingTextBox>
              <Text>
                <AlignLeft>
                  마케팅 컨텐츠 제작을 {"\n"}위한 맞춤형 컨설팅 진행
                </AlignLeft>
              </Text>
              <Text fontSize="18px" marginTop="10px" fontWeight="Regular">
                <AlignLeft>모든 과정은 슬라임 대표가 직접 관여합니다</AlignLeft>
              </Text>
            </MarketingTextBox>
            <MarketProcessContainer>
              {processData.map((data, index) => (
                <>
                  <ProcessComponent key={index}>
                    {/* 이미지 대신 Icon을 img로 대체, 너비와 높이를 설정 */}
                    <Circle>
                      <Icon
                        src={data.imgSrc}
                        width={data.imgWidth}
                        height={data.imgHeight}
                      />
                    </Circle>
                    <Text fontSize="22px" color="#00E186">
                      {data.titleText}
                    </Text>
                    <Text fontSize="17px" color="white" fontWeight="Regular">
                      {data.summaryText}
                    </Text>
                  </ProcessComponent>
                  {index < processData.length - 1 && (
                    <Icon
                      src="./images/marketing_icon/flow_icon/arrow.png"
                      width="22px"
                      height="28px"
                      margin="0px"
                    />
                  )}
                </>
              ))}
            </MarketProcessContainer>
          </MarketingFlowContainer>
        </>
      )}

      <InquireComponent isMobile={isMobile} />
    </Container>
  );
}

export default Marketing;
